import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Globe, MapPin, Clock, Heart } from "lucide-react";
import Logo from "./Logo";
import { companyInfo, services } from "../data/mockData";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-stone-100" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 pb-16">
          {/* Brand */}
          <div className="lg:col-span-5">
            <Logo variant="light" size="default" />
            <p className="mt-6 text-stone-300 text-base leading-relaxed max-w-md">
              {companyInfo.mission}
            </p>
            <p className="mt-6 font-script text-2xl text-amber-400">
              Because every life deserves a blessing.
            </p>
          </div>

          {/* Services */}
          <div className="lg:col-span-3">
            <h4 className="font-serif text-lg mb-5 text-white">Our Services</h4>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s.id}>
                  <Link
                    to={`/services#${s.id}`}
                    className="text-stone-300 hover:text-amber-400 text-sm transition-colors"
                    data-testid={`footer-service-${s.id}`}
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick links */}
          <div className="lg:col-span-2">
            <h4 className="font-serif text-lg mb-5 text-white">Company</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-stone-300 hover:text-amber-400 text-sm transition-colors">About Us</Link></li>
              <li><Link to="/testimonials" className="text-stone-300 hover:text-amber-400 text-sm transition-colors">Testimonials</Link></li>
              <li><Link to="/blog" className="text-stone-300 hover:text-amber-400 text-sm transition-colors">Resources</Link></li>
              <li><Link to="/contact" className="text-stone-300 hover:text-amber-400 text-sm transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-2">
            <h4 className="font-serif text-lg mb-5 text-white">Let's Talk</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-stone-300">
                <Phone className="w-4 h-4 mt-0.5 text-amber-400 flex-shrink-0" />
                <a href={`tel:${companyInfo.phone.replace(/\D/g, "")}`} className="hover:text-amber-400" data-testid="footer-phone">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-stone-300">
                <Mail className="w-4 h-4 mt-0.5 text-amber-400 flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="hover:text-amber-400 break-all" data-testid="footer-email">
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-stone-300">
                <Clock className="w-4 h-4 mt-0.5 text-amber-400 flex-shrink-0" />
                <span>{companyInfo.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-stone-400 text-xs tracking-wider uppercase">
            Companion Care <Heart className="inline w-3 h-3 mx-2 text-amber-400" fill="currentColor" /> Personal Attention <Heart className="inline w-3 h-3 mx-2 text-amber-400" fill="currentColor" /> Delivering Dignity and Respect
          </p>
          <p className="text-stone-500 text-xs">
            &copy; {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
